const ITEMS = [
  "Specialità Halal",
  "Spezie & Aromi",
  "Couscous & Semole",
  "Olio Extravergine",
  "Olive & Conserve",
  "Tisane & Tè Pregiati",
  "Frutta Secca & Datteri",
  "Salumi Halal Selezionati",
  "Legumi & Farine",
];

function Row() {
  return (
    <div className="flex items-center gap-12 pr-12">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center gap-12">
          <span>{item}</span>
          <span className="text-white/40">✦</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="categories-marquee" className="py-5 bg-[#0b2545] text-[#d4af37] border-y border-[#d4af37]/30 overflow-hidden">
      <div className="df-mq-track font-display text-lg tracking-wider uppercase">
        <Row />
        <Row />
      </div>
    </div>
  );
}
